import { useSettingsContext } from '@/contexts/SettingsContext'

export interface EventCopy {
  hostTitle: string
  eventName: string
  guestTitle: string
  blessingTitle: string
  blessingSubtitle: string
  angpaoSubtitle: string
}

export function getEventCopy(eventType?: string): EventCopy {
  const isWedding = eventType?.toLowerCase() === 'wedding'

  if (isWedding) {
    return {
      hostTitle: 'คู่บ่าวสาว',
      eventName: 'งานแต่งงาน',
      guestTitle: 'แขกผู้มีเกียรติ',
      blessingTitle: 'ส่งคำอวยพร',
      blessingSubtitle: 'เขียนคำอวยพรแด่คู่บ่าวสาว',
      angpaoSubtitle: 'ของขวัญแด่คู่บ่าวสาว',
    }
  }

  return {
    hostTitle: 'ผู้จัดงาน',
    eventName: 'กิจกรรม',
    guestTitle: 'ผู้เข้าร่วมงาน',
    blessingTitle: 'ส่งคำอวยพร',
    blessingSubtitle: 'เขียนข้อความหรือคำอวยพร',
    angpaoSubtitle: 'ของขวัญ / สนับสนุนกิจกรรม',
  }
}

export function useEventCopy(): EventCopy {
  const { settings } = useSettingsContext()
  const eventType =
    (settings as any)?.eventType || (settings as any)?.event_type
  return getEventCopy(eventType)
}
